import { CustomerEmploymentStatus } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const employmentStatusMessages = defineMessages({
  civilServant: {
    defaultMessage: 'Civil servant',
    description: 'employment status title',
  },
  contractEmployee: {
    defaultMessage: 'Contract employee',
    description: 'employment status title',
  },
  freelance: {
    defaultMessage: 'Freelance',
    description: 'employment status title',
  },
  homemaker: {
    defaultMessage: 'Homemaker',
    description: 'employment status title',
  },
  other: {
    defaultMessage: 'Other',
    description: 'employment status title',
  },
  permanentEmployee: {
    defaultMessage: 'Permanent employee',
    description: 'employment status title',
  },
  retired: {
    defaultMessage: 'Retired',
    description: 'employment status title',
  },
  selfEmployed: {
    defaultMessage: 'Self-employed',
    description: 'employment status title',
  },
  student: {
    defaultMessage: 'Student',
    description: 'employment status title',
  },
  unemployed: {
    defaultMessage: 'Unemployed',
    description: 'employment status title',
  },
})

export function translateEmploymentStatus(
  intl: IntlShape,
  status: CustomerEmploymentStatus,
): string {
  switch (status) {
    case CustomerEmploymentStatus.CIVIL_SERVANT:
      return intl.formatMessage(employmentStatusMessages.civilServant)
    case CustomerEmploymentStatus.CONTRACT_EMPLOYEE:
      return intl.formatMessage(employmentStatusMessages.contractEmployee)
    case CustomerEmploymentStatus.FREELANCE:
      return intl.formatMessage(employmentStatusMessages.freelance)
    case CustomerEmploymentStatus.HOMEMAKER:
      return intl.formatMessage(employmentStatusMessages.homemaker)
    case CustomerEmploymentStatus.OTHER:
      return intl.formatMessage(employmentStatusMessages.other)
    case CustomerEmploymentStatus.PERMANENT_EMPLOYEE:
      return intl.formatMessage(employmentStatusMessages.permanentEmployee)
    case CustomerEmploymentStatus.RETIRED:
      return intl.formatMessage(employmentStatusMessages.retired)
    case CustomerEmploymentStatus.SELF_EMPLOYED:
      return intl.formatMessage(employmentStatusMessages.selfEmployed)
    case CustomerEmploymentStatus.STUDENT:
      return intl.formatMessage(employmentStatusMessages.student)
    case CustomerEmploymentStatus.UNEMPLOYED:
      return intl.formatMessage(employmentStatusMessages.unemployed)
  }
}
